export const frenchFlashcards = {
  categories: [
    {
      fr: "Bonjour",
      rm: "Bohn-zhoor",
      en: "Hello / Good morning / Good day",
    },
    {
      fr: "Bonsoir",
      rm: "Bohn-swahr",
      en: "Good evening / Good night",
    },
    {
      fr: "Salut",
      rm: "Sa-lyu",
      en: "Hi / Bye (informal)",
    },
    {
      fr: "Au revoir",
      rm: "O-ruh-vwahr",
      en: "Goodbye",
    },
    {
      fr: "À bientôt",
      rm: "Ah-byen-toh",
      en: "See you soon",
    },
    {
      fr: "Merci",
      rm: "Mehr-see",
      en: "Thank you",
    },
    {
      fr: "Merci beaucoup",
      rm: "Mehr-see boh-koo",
      en: "Thank you very much",
    },
    {
      fr: "De rien",
      rm: "Duh-ryehn",
      en: "You're welcome",
    },
    {
      fr: "S'il vous plaît",
      rm: "Seel-voo-pleh",
      en: "Please (formal)",
    },
    {
      fr: "S'il te plaît",
      rm: "Seel-tuh-pleh",
      en: "Please (informal)",
    },
    {
      fr: "Excusez-moi",
      rm: "Ex-kyoo-zay-mwah",
      en: "Excuse me (formal)",
    },
    {
      fr: "Pardon",
      rm: "Pahr-dohn",
      en: "Excuse me / Sorry",
    },
    {
      fr: "Oui",
      rm: "Wee",
      en: "Yes",
    },
    {
      fr: "Non",
      rm: "Nohn",
      en: "No",
    },
    {
      fr: "D'accord",
      rm: "Dah-kohr",
      en: "Okay / Agreed",
    },
    {
      fr: "Je ne comprends pas",
      rm: "Zhuh nuh kohn-prahn pah",
      en: "I don't understand",
    },
    {
      fr: "Parlez-vous anglais?",
      rm: "Pahr-lay voo ahn-gleh?",
      en: "Do you speak English? (formal)",
    },
    {
      fr: "Tu parles anglais?",
      rm: "Tyoo pahrl ahn-gleh?",
      en: "Do you speak English? (informal)",
    },
    {
      fr: "Comment allez-vous?",
      rm: "Koh-mahn-tal-ay-voo?",
      en: "How are you? (formal)",
    },
    {
      fr: "Comment vas-tu?",
      rm: "Koh-mahn vah-tyoo?",
      en: "How are you? (informal)",
    },
    {
      fr: "Ça va?",
      rm: "Sah vah?",
      en: "How's it going? / Are you okay?",
    },
    {
      fr: "Ça va bien, merci",
      rm: "Sah vah byen, mehr-see",
      en: "I'm fine, thank you",
    },
    {
      fr: "Quel est votre nom?",
      rm: "Kehl ay vo-truh nohn?",
      en: "What is your name? (formal)",
    },
    {
      fr: "Comment tu t'appelles?",
      rm: "Koh-mahn tyoo tah-pehl?",
      en: "What is your name? (informal)",
    },
    {
      fr: "Je m'appelle...",
      rm: "Zhuh mah-pehl...",
      en: "My name is...",
    },
    {
      fr: "Où est...?",
      rm: "Oo ay...?",
      en: "Where is...?",
    },
    {
      fr: "Où sont les toilettes?",
      rm: "Oo sohn lay twah-leht?",
      en: "Where are the toilets?",
    },
    {
      fr: "Où est la gare?",
      rm: "Oo ay la gahr?",
      en: "Where is the train station?",
    },
    {
      fr: "Où est l'aéroport?",
      rm: "Oo ay lay-air-oh-pohr?",
      en: "Where is the airport?",
    },
    {
      fr: "Combien ça coûte?",
      rm: "Kohm-byen sah koot?",
      en: "How much does it cost?",
    },
    {
      fr: "C'est trop cher",
      rm: "Say troh shehr",
      en: "It's too expensive",
    },
    {
      fr: "Aidez-moi!",
      rm: "Ay-day-mwah!",
      en: "Help me!",
    },
    {
      fr: "Au secours!",
      rm: "O-skoo-ruh!",
      en: "Help!",
    },
    {
      fr: "Je suis perdu(e)",
      rm: "Zhuh swee pehr-dyoo (pehr-dy)",
      en: "I am lost (female/male)",
    },
    {
      fr: "Je cherche...",
      rm: "Zhuh shehrsh...",
      en: "I'm looking for...",
    },
    {
      fr: "Je voudrais...",
      rm: "Zhuh voo-dreh...",
      en: "I would like...",
    },
    {
      fr: "Je veux...",
      rm: "Zhuh vuh...",
      en: "I want...",
    },
    {
      fr: "Un café, s'il vous plaît",
      rm: "Un kah-fay, seel voo pleh",
      en: "A coffee, please",
    },
    {
      fr: "L'addition, s'il vous plaît",
      rm: "La-dee-syohn, seel voo pleh",
      en: "The bill, please",
    },
    {
      fr: "Je suis végétarien(ne)",
      rm: "Zhuh swee vay-zhay-tah-ryen (vay-zhay-tah-ryenn)",
      en: "I am vegetarian (male/female)",
    },
    {
      fr: "Je suis allergique à...",
      rm: "Zhuh swee ah-lehr-zheek ah...",
      en: "I am allergic to...",
    },
    {
      fr: "C'est délicieux",
      rm: "Say day-lee-syuh",
      en: "It's delicious",
    },
    {
      fr: "À la vôtre!",
      rm: "Ah la vo-truh!",
      en: "Cheers!",
    },
    {
      fr: "Je ne me sens pas bien",
      rm: "Zhuh nuh muh sahn pah byen",
      en: "I don't feel well",
    },
    {
      fr: "Où est l'hôpital?",
      rm: "Oo ay lo-pee-tahl?",
      en: "Where is the hospital?",
    },
    {
      fr: "Je parle un peu français",
      rm: "Zhuh pahrl uhn puh frahn-say",
      en: "I speak a little French",
    },
    {
      fr: "Plus lentement, s'il vous plaît",
      rm: "Ploo lahn-tuh-mahn, seel voo pleh",
      en: "More slowly, please",
    },
    {
      fr: "Pouvez-vous répéter?",
      rm: "Poo-vay-voo ray-pay-tay?",
      en: "Can you repeat that?",
    },
    {
      fr: "Je suis fatigué(e)",
      rm: "Zhuh swee fah-tee-gay (fah-tee-gay)",
      en: "I am tired (male/female)",
    },
    {
      fr: "Quel temps fait-il?",
      rm: "Kehl tahn fay-teel?",
      en: "What's the weather like?",
    },
    {
      fr: "Il fait beau",
      rm: "Eel fay boh",
      en: "The weather is nice",
    },
    {
      fr: "Il fait chaud",
      rm: "Eel fay shoh",
      en: "It's hot",
    },
    {
      fr: "Il fait froid",
      rm: "Eel fay frwah",
      en: "It's cold",
    },
    {
      fr: "Il pleut",
      rm: "Eel pluh",
      en: "It's raining",
    },
    {
      fr: "Je suis d'accord",
      rm: "Zhuh swee dah-kohr",
      en: "I agree",
    },
    {
      fr: "Je ne suis pas d'accord",
      rm: "Zhuh nuh swee pah dah-kohr",
      en: "I disagree",
    },
    {
      fr: "C'est intéressant",
      rm: "Say-tahn-tay-reh-sohn",
      en: "It's interesting",
    },
    {
      fr: "C'est important",
      rm: "Say-tahn-pohr-tahn",
      en: "It's important",
    },
    {
      fr: "C'est possible",
      rm: "Say poh-seebl",
      en: "It's possible",
    },
    {
      fr: "C'est impossible",
      rm: "Say-tahn-poh-seebl",
      en: "It's impossible",
    },
    {
      fr: "Quelle heure est-il?",
      rm: "Kehl uhr ay-teel?",
      en: "What time is it?",
    },
    {
      fr: "Aujourd'hui",
      rm: "O-zhoor-dwee",
      en: "Today",
    },
    {
      fr: "Demain",
      rm: "Duh-mehn",
      en: "Tomorrow",
    },
    {
      fr: "Hier",
      rm: "Yehr",
      en: "Yesterday",
    },
    {
      fr: "Maintenant",
      rm: "Mehn-tuh-nahn",
      en: "Now",
    },
    {
      fr: "Plus tard",
      rm: "Ploo tahr",
      en: "Later",
    },
    {
      fr: "À droite",
      rm: "Ah drwaht",
      en: "To the right",
    },
    {
      fr: "À gauche",
      rm: "Ah gohsh",
      en: "To the left",
    },
    {
      fr: "Tout droit",
      rm: "Too drwah",
      en: "Straight ahead",
    },
    {
      fr: "Proche",
      rm: "Prohsh",
      en: "Near",
    },
    {
      fr: "Loin",
      rm: "Lwan",
      en: "Far",
    },
    {
      fr: "Je suis perdu(e)",
      rm: "Zhuh swee pehr-dyoo (pehr-due)",
      en: "I'm lost (male/female)",
    },
    {
      fr: "Je suis malade",
      rm: "Zhuh swee mah-lahd",
      en: "I am sick",
    },
    {
      fr: "C'est urgent",
      rm: "Say-tur-zhahn",
      en: "It's urgent",
    },
    {
      fr: "Un instant, s'il vous plaît",
      rm: "Un-nan-stahn, seel voo pleh",
      en: "One moment, please",
    },
    {
      fr: "Je ne sais pas",
      rm: "Zhuh nuh say pah",
      en: "I don't know",
    },
    {
      fr: "C'est bon",
      rm: "Say bohn",
      en: "It's good / It's okay",
    },
    {
      fr: "C'est pas grave",
      rm: "Say pah grahv",
      en: "It's not a big deal / It doesn't matter",
    },
    {
      fr: "Pas de problème",
      rm: "Pah duh proh-blehm",
      en: "No problem",
    },
    {
      fr: "Faites attention!",
      rm: "Feht ah-tahn-syohn!",
      en: "Be careful!",
    },
    {
      fr: "Laissez-moi tranquille",
      rm: "Lay-say-mwah trahn-keel",
      en: "Leave me alone",
    },
    {
      fr: "J'ai faim",
      rm: "Zhay fehn",
      en: "I'm hungry",
    },
    {
      fr: "J'ai soif",
      rm: "Zhay swahf",
      en: "I'm thirsty",
    },
    {
      fr: "Je suis désolé(e)",
      rm: "Zhuh swee day-zoh-lay (day-zoh-lay)",
      en: "I'm sorry (male/female)",
    },
    {
      fr: "Félicitations!",
      rm: "Fay-lee-see-tah-syohn!",
      en: "Congratulations!",
    },
    {
      fr: "Bonne chance!",
      rm: "Bohn shahnss!",
      en: "Good luck!",
    },
    {
      fr: "Bon voyage!",
      rm: "Bohn vwah-yahzh!",
      en: "Have a good trip!",
    },
    {
      fr: "À votre santé!",
      rm: "Ah vo-truh sahn-tay!",
      en: "To your health! (Cheers)",
    },
    {
      fr: "C'est gratuit?",
      rm: "Say gra-twee?",
      en: "Is it free?",
    },
    {
      fr: "Quel est le code wifi?",
      rm: "Kehl ay luh kohd wee-fee?",
      en: "What is the wifi password?",
    },
    {
      fr: "Je peux prendre une photo?",
      rm: "Zhuh puh prahn-druh oon fo-toh?",
      en: "Can I take a picture?",
    },
  ],
};
